import {App} from "./js/App";

new App().render();
